export default __webpack_public_path__ + "static/media/multi-part-parent-icon.887b7ee0.png";